export const getParams = () => {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      if (pair[0] === "bank") {
        return pair[1];
      }
    }
    return ("centralbank");
};

export const getParametersValue = () => {
  const bankValues = ['bankcentral', 'centralbank', 'jefferson'];
  let paramValue = getParams();
  let bank, market;

  if (bankValues.includes(paramValue)) {
      bank = paramValue;
      market = 'central'; 
  } else {
      bank = 'centralbank';
      market = paramValue;
  }
  return { bank, market };
};

